import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.css']
})
export class LoadingBarComponent {}



// WEBPACK FOOTER //
// ./src/app/core/components/loading-bar/loading-bar.component.ts